export const SOCKETS_CONNECT = "CONNECT"
export const SOCKETS_CONNECTED = "SOCKETS_CONNECTED"
export const SOCKETS_CONNECTING = "SOCKETS_CONNECTING"
export const SOCKETS_DISCONNECT = "DISCONNECT"
export const SOCKETS_DISCONNECTING = "SOCKETS_DISCONNECTING"
export const SOCKETS_DISCONNECTED = "SOCKETS_DISCONNECTED"
export const SOCKETS_MESSAGE_SENDING = "SOCKETS_MESSAGE_SENDING"
export const SOCKETS_MESSAGE_RECEIVING = "SOCKETS_MESSAGE_RECEIVING"

export function connect(data) {
    return { type: SOCKETS_CONNECT, apiKey: data }
}
export function connected() {
    return { type: SOCKETS_CONNECTED }
}
export function connecting() {
    return { type: SOCKETS_CONNECTING }
}
export function disconnect() {
    return { type: SOCKETS_DISCONNECT }
}
export function disconnecting() {
    return { type: SOCKETS_DISCONNECTING }
}
export function disconnected() {
    return { type: SOCKETS_DISCONNECTED }
}
export function messageSending() {
    return { type: SOCKETS_MESSAGE_SENDING }
}
export function messageReceiving() {
    return { type: SOCKETS_MESSAGE_RECEIVING }
}

export const subscribe = (messageCallback, statusCallback) => {
    return {
        type: "SUBSCRIBE",
        messageCallback: messageCallback,
        statusCallback: statusCallback,
    }
}

export const unsubscribe = (messageCallback, statusCallback) => {
    return {
        type: "UNSUBSCRIBE",
        messageCallback: messageCallback,
        statusCallback: statusCallback,
    }
}

export const send = (cmd, data) => dispatch => {
    return new Promise((resolve, reject) => {
        dispatch({
            type: "SEND",
            cmd: cmd,
            data: data,
            resolve: resolve,
            reject: reject,
        })
    })
}